import React, { useEffect } from "react";
import { Button, Image } from "react-bootstrap";
import { useFormContext } from "react-hook-form";

import { CustomTitleLabel } from "components/earning/CustomBaseComponments";
import deleteIcon from 'assets/images/drop_down_delete_selected.png'
import { ReactHookFormErrorMessage } from "components/base/ErrorFieldMessage";

const additionalDataPlaceholder = [
    {
        title: "",
        value: "",
    }
];

function SingleAdditionalDataSection({
    index = null,
    listLength = null,
    additionalDataField = 'additionalData'
}) {
    const { watch, setValue, formState } = useFormContext();
    const { errors } = formState;
    const additionalData = watch(additionalDataField) || [];
    const dataTitleField = `${additionalDataField}.${index}.title`;
    const dataValueField = `${additionalDataField}.${index}.value`;
    const dataTitle = watch(dataTitleField);
    const dataValue = watch(dataValueField);

    const deleteButton = () => {
        if (listLength < 2) {
            return null
        }
        return (
            <Image
                src={deleteIcon}
                className="delete-img"
                onClick={(e) => {
                    const newListAfterRemoved = additionalData.filter((item, listIndex) => listIndex != index);
                    setValue(additionalDataField, newListAfterRemoved, { shouldDirty: true });
                }}
            />
        )
    }

    const inputItem = ({ filedName, fieldValue, labelName }) => {
        return (
            <div>
                <div className="d-flex">
                    <label>{labelName}</label>
                    <input
                        type="text"
                        className={`text-input-field`}
                        value={fieldValue || ""}
                        onChange={(e) => {
                            setValue(filedName, e.target.value, { shouldDirty: true });
                        }}
                    />
                </div>
                <ReactHookFormErrorMessage errors={errors} id={filedName} />
            </div>
        )
    }

    return (
        <div className="single-additional-data-section">
            <div className="title-and-delete">
                <CustomTitleLabel title={`Fields #${index + 1}`} />
                {deleteButton()}
            </div>
            {inputItem({ filedName: dataTitleField, fieldValue: dataTitle, labelName: "Title" })}
            {inputItem({ filedName: dataValueField, fieldValue: dataValue, labelName: "Value" })}
        </div>
    )


}

function AdditionalDataSection({
    showTitle = false,
    additionalDataField = 'additionalData'
}) {
    const { watch, setValue } = useFormContext();
    const additionalData = watch(additionalDataField) || [];

    useEffect(() => {
        if (!additionalData.length) {
            setValue(additionalDataField, additionalDataPlaceholder, { shouldDirty: true });
        }
    }, [])

    if (!additionalData.length) {
        return null
    }

    const sectionTitle = () => {
        if (!showTitle) {
            return null
        }
        return (
            <div className="first-section-title">
                {"ADDITIONAL DATA (optional)"}
            </div>
        )
    }

    const addNew = () => {
        return (
            <div className="content-section-table-container">
                <Button
                    onClick={() => {
                        setValue(additionalDataField, [...additionalData, ...additionalDataPlaceholder], { shouldDirty: true, });
                    }}
                    className="btn-add-button-common"
                >
                    Add field
                </Button>
            </div>
        )
    }

    return (
        <>
            {sectionTitle()}
            {additionalData.map(
                (item, index) => (
                    <SingleAdditionalDataSection
                        index={index}
                        listLength={additionalData.length}
                        additionalDataField={additionalDataField}
                    />

                )
            )}
            {addNew()}
        </>
    )
}

export default AdditionalDataSection;